import React from 'react';
import ReactPaginate from 'react-paginate';

const AuditLogsView = ({
  pagedFilteredData,
  searchTerm,
  setSearchTerm,
  pageCount,
  handlePageClick,
}) => {
  return (
    <>
      <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <input
          type="text"
          placeholder="Search audit logs..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          style={{
            width: 300,
            padding: '8px 12px',
            borderRadius: 4,
            border: '1px solid #ccc',
            fontSize: 16,
            outline: 'none',
          }}
        />
      </div>
      <div style={{ marginBottom: 24, boxShadow: '0 2px 8px rgba(0,0,0,0.1)', borderRadius: 8, backgroundColor: '#fff',
        scrollbarWidth: 'thin',
        scrollbarColor: '#1976d2 #e0e0e0',
        maxWidth: 'calc(100% - 20px)',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}>
        <style>
          {`
            /* For Chrome, Edge, and Safari */
            div::-webkit-scrollbar {
              width: 8px;
            }
            div::-webkit-scrollbar-track {
              background: #f1f1f1;
              border-radius: 8px;
            }
            div::-webkit-scrollbar-thumb {
              background-color: #1976d2;
              border-radius: 8px;
              border: 2px solid #f1f1f1;
            }
            /* Table styling */
            table {
              width: 100%;
              max-width: calc(100% - 60px);
              margin-left: auto;
              margin-right: auto;
              border-collapse: collapse;
              font-family: Arial, sans-serif;
              table-layout: fixed;
            }
            thead tr {
              /* Removed background color */
              color: black;
              text-align: left;
            }
            thead th {
              padding: 12px 15px;
              font-weight: bold;
              border-bottom: 2px solid #ccc;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            tbody tr {
              border-bottom: 1px solid #ddd;
              transition: background-color 0.3s ease;
            }
            tbody tr:hover {
              background-color: #f0f4ff;
            }
            tbody td {
              padding: 12px 15px;
              vertical-align: middle;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .pagination {
              display: flex;
              justify-content: center;
              list-style: none;
              padding: 0;
              margin-top: 20px;
            }
            .pagination li {
              margin: 0 5px;
            }
            .pagination li a {
              cursor: pointer;
              padding: 8px 12px;
              border-radius: 4px;
              color: #1976d2;
              border: 1px solid #1976d2;
              transition: background-color 0.3s, color 0.3s;
            }
            .pagination li a:hover {
              background-color: #e3f2fd;
            }
            .pagination li.active a {
              background-color: #1976d2;
              color: white;
              border-color: #1976d2;
            }
            .pagination li.disabled a {
              color: #ccc;
              border-color: #ccc;
              cursor: not-allowed;
            }
          `}
        </style>
        <table>
          <thead>
            <tr>
              <th>User</th>
              <th>Action</th>
              <th>Details</th>
              <th>Timestamp</th>
            </tr>
          </thead>
          <tbody>
            {pagedFilteredData.map((row, i) => (
              <tr key={i} style={{ cursor: 'default' }}>
                <td>{row.user_id}</td>
                <td>{row.action}</td>
                <td>{row.details}</td>
                <td>{row.timestamp}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {pageCount > 1 && (
        <ReactPaginate
          previousLabel={'previous'}
          nextLabel={'next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          activeClassName={'active'}
        />
      )}
    </>
  );
};

export default AuditLogsView;